import { render, staticRenderFns } from "./LiteTips.vue?vue&type=template&id=5b82af9d&scoped=true&"
import script from "./LiteTips.vue?vue&type=script&lang=js&"
export * from "./LiteTips.vue?vue&type=script&lang=js&"
import style0 from "./LiteTips.vue?vue&type=style&index=0&id=5b82af9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82af9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b82af9d')) {
      api.createRecord('5b82af9d', component.options)
    } else {
      api.reload('5b82af9d', component.options)
    }
    module.hot.accept("./LiteTips.vue?vue&type=template&id=5b82af9d&scoped=true&", function () {
      api.rerender('5b82af9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tips/LiteTips.vue"
export default component.exports